import ServiceList from ".";
import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import ServiceCategory from "../ServiceCategory";
import ServiceTags from "../ServiceTags";

const tabRoutes = [
  {
    label: "List",
    icon: "fa-brands fa-servicestack",
    path: "/admin/services",
  },
  {
    label: "Categories",
    icon: "fa-regular fa-layer-group",
    path: "/admin/services-categories",
  },
  {
    label: "Tags",
    icon: "fa-regular fa-tags",
    path: "/admin/services-tags",
  },
];

export const serviceRoutes = () => [
  {
    path: "/admin/services",
    title: "Features Management",
    layout: "admin",
    routeType: "admin",
    component: () => (
      <TabsNavigation title="Features Management" tabRoutes={tabRoutes}>
        <ServiceList />
      </TabsNavigation>
    ),
  },
  {
    path: "/admin/services-categories",
    title: "Features Management",
    layout: "admin",
    routeType: "admin",
    component: () => (
      <TabsNavigation title="Features Management" tabRoutes={tabRoutes}>
        <ServiceCategory />
      </TabsNavigation>
    ),
  },
  {
    path: "/admin/services-tags",
    title: "Features Management",
    layout: "admin",
    routeType: "admin",
    component: () => (
      <TabsNavigation title="Features Management" tabRoutes={tabRoutes}>
        <ServiceTags />
      </TabsNavigation>
    ),
  },
];
